<template>

  <div class="modal" :class="{ active : active }">
    <div class="modal-background"></div>
    <div class="modal-content">
      <iframe-loader :url="videoURL" v-if="videoURL" alwaysShow></iframe-loader>
    </div>
    <a href="" class="modal-close" @click.prevent="closeModal()"></a>
  </div>

</template>


<script type="text/babel">

import IframeLoader from './iframe-loader.vue'

export default {

  data() {
    return {
      active: false,
      videoURL: '',
    }
  },

  components: {
    'iframe-loader' : IframeLoader
  },

  mounted() {
    Event.listen('open-modal', this.openModal);
  },

  props: {
    heading: { type: String, default: '' },
    body: { type: String, default: '' },
  },


  methods: {
    openModal(url) {
      document.body.classList.add('modal-active');
      this.videoURL = url;
      this.active = true;
      Event.emit('video-background-pause');

    },

    closeModal() {
      document.body.classList.remove('modal-active');
      setTimeout(()=>{
        this.videoURL = '';
      }, 500)
      this.active = false;
      Event.emit('video-background-play')
    }
  }
}

</script>
